import React, { memo, useCallback } from 'react';

import { ThreeDStockLifestylesCompactListItemLifestyle } from './ThreeDStockLifestylesCompactListItem.types';
import {
  LifestyleNanoID,
  UpdateLifestyleCacheAction
} from '../../../../lifestyles/lifestylesTypes';
import { OnLightboxOpenAction } from '../../../../../helpers/LightboxWrapper';
import { TeamNanoID } from '../../../../teams/teamsTypes';

import { ThreeDStockLifestylesCompactListItemPreview } from './components/ThreeDStockLifestylesCompactListItemPreview';
import { ThreeDStockLifestylesCompactListItemInfo } from './components/ThreeDStockLifestylesCompactListItemInfo';
import { ThreeDStockLifestylesCompactListItemButtons } from './components/ThreeDStockLifestylesCompactListItemButtons';

type ThreeDStockLifestylesCompactListItemProps = {
  lifestyle: ThreeDStockLifestylesCompactListItemLifestyle;
  onLifestyleEditButtonMouseEnter?: (lifestyleNanoId: LifestyleNanoID) => void;
  onLightboxOpen: OnLightboxOpenAction;
  updateLifestyleCache?: UpdateLifestyleCacheAction<ThreeDStockLifestylesCompactListItemLifestyle>;
  companyNanoId?: TeamNanoID;
  isMyLibrary?: boolean;
};

function ThreeDStockLifestylesCompactListItem({
  lifestyle,
  onLifestyleEditButtonMouseEnter,
  onLightboxOpen,
  updateLifestyleCache,
  companyNanoId,
  isMyLibrary
}: ThreeDStockLifestylesCompactListItemProps) {
  const handleOpenLightbox = useCallback(() => {
    if (lifestyle.image) {
      onLightboxOpen(lifestyle);
    }
  }, [lifestyle, onLightboxOpen]);

  const handleEditButtonMouseEnter = useCallback<() => void>(() => {
    onLifestyleEditButtonMouseEnter(lifestyle.nanoId);
  }, [onLifestyleEditButtonMouseEnter, lifestyle.nanoId]);

  return (
    <div className="group rounded-xl relative has-[:checked]:ring has-[:checked]:bg-blue-500/20 has-[:checked]:hover:bg-blue-500/20 dark:has-[:checked]:hover:bg-blue-500/20 hover:bg-gray-100 dark:hover:bg-gray-850 flex gap-4 items-center p-2 max-w-full transition-colors duration-150 ease-out">
      <ThreeDStockLifestylesCompactListItemPreview
        lifestyle={lifestyle}
        onLightboxOpen={handleOpenLightbox}
      />

      <ThreeDStockLifestylesCompactListItemInfo lifestyle={lifestyle} />

      <ThreeDStockLifestylesCompactListItemButtons
        lifestyle={lifestyle}
        updateLifestyleCache={updateLifestyleCache}
        onEditButtonMouseEnter={handleEditButtonMouseEnter}
        companyNanoId={companyNanoId}
        isMyLibrary={isMyLibrary}
      />
    </div>
  );
}

export default memo<ThreeDStockLifestylesCompactListItemProps>(
  ThreeDStockLifestylesCompactListItem
);
